import makeApiRequest from "../../api/makeApiCall";
import { Config } from "../../latest/src/constants/AppServerConfig";

const LOGGING_SERVICE = Config.loggingService;
const USER_SERVICE = Config.userServiceRestApiV1;

export const getOnBoardingAuditLogs = async (
    userId: string,
    offset: number,
) => {
    return await makeApiRequest(
        `${LOGGING_SERVICE}user/${userId}/onboarding-audit-log?offset=${
            offset || 0
        }`
    );
};

export const existingUser  = async (userName : string) =>{
    return await makeApiRequest(`${USER_SERVICE}users/_search?is_profile_required=false&limit=20&offset=0&user_name=${encodeURIComponent(userName)}&active=true`, 'GET');
};

export const getUserDocuments = async (userId: string) => {
    return await makeApiRequest(`${USER_SERVICE}documents/${userId}`);
};


export const updateIfollowedUpTodo = async (todoId: string, data: object) => {
    return await makeApiRequest(
        `${USER_SERVICE}todos/${todoId}/_follow-up`,
        "POST",
        data
    );
};

export const addTodo = async (userId: string, data: object) => {
    return await makeApiRequest(
        `${USER_SERVICE}todo/${userId}`,
        "POST",
        data
    );
};

export const addNote = async (userId: string, note: string) => {
    return await makeApiRequest(
        `${USER_SERVICE}users/${userId}/_notes`,
        "POST",
        {
            note
        }
    );
};

export const assignScheduler = async (
    userId: string,
    schedulerId: string,
    note?: string
) => {
    return await makeApiRequest(
        `${USER_SERVICE}users/${userId}/_assign-scheduler`,
        "POST",
        { note: note || "", scheduler_id: schedulerId }
    );
};

export const changeOnboardingStatus = async (
    userId: string,
    status: string,
    note: string
) => {
    return await makeApiRequest(
        `${USER_SERVICE}users/${userId}/_onboarding-status`,
        "PUT",
        {
            status,
            note,
        }
    );
};

export const getSelfOnBoardingStats = async (
  startDate: string,
  endDate: string,
) => {
  return await makeApiRequest(
    `${LOGGING_SERVICE}stats/_self-onboarding`,
    'POST',
    { endDate, startDate },
  );
};

export const getCardStats = async (
    startDate: string,
    endDate: string,
  ) => {
    return await makeApiRequest(
      `${LOGGING_SERVICE}stats/_cards`,
      'POST',
      { endDate, startDate },
    );
  };